export const PERSONAS = {
  courageous: {
    id: 'courageous',
    name: 'Courageous',
    tagline: 'You lead. Others follow.',
    description: 'Ai curajul să fii primul. Adrenalina e combustibilul tău.',
    color: '#e85d2f',
    colorLight: '#f97316',
    gradient: 'linear-gradient(135deg, #c2410c 0%, #e85d2f 50%, #f97316 100%)',
    glowColor: 'rgba(232, 93, 47, 0.6)',
    badgeColor: '#e85d2f',
  },
  inspirational: {
    id: 'inspirational',
    name: 'Inspirational',
    tagline: 'You light up every room.',
    description: 'Energia ta e contagioasă. Inspiri pe toată lumea în jur.',
    color: '#00b89f',
    colorLight: '#2dd4bf',
    gradient: 'linear-gradient(135deg, #0f766e 0%, #00b89f 50%, #2dd4bf 100%)',
    glowColor: 'rgba(0, 184, 159, 0.6)',
    badgeColor: '#00b89f',
  },
  authentic: {
    id: 'authentic',
    name: 'Authentic',
    tagline: 'Real recognizes real.',
    description: 'Nu te prefaci. Ești 100% tu însuți, mereu.',
    color: '#4f8ef7',
    colorLight: '#60a5fa',
    gradient: 'linear-gradient(135deg, #1d4ed8 0%, #4f8ef7 50%, #60a5fa 100%)',
    glowColor: 'rgba(79, 142, 247, 0.6)',
    badgeColor: '#4f8ef7',
  },
  independent: {
    id: 'independent',
    name: 'Independent',
    tagline: 'Your rules. Your world.',
    description: 'Faci ce vrei, cum vrei. Regulile le faci tu.',
    color: '#8b3fa8',
    colorLight: '#a855f7',
    gradient: 'linear-gradient(135deg, #5b21b6 0%, #8b3fa8 50%, #a855f7 100%)',
    glowColor: 'rgba(139, 63, 168, 0.6)',
    badgeColor: '#8b3fa8',
  },
  visionary: {
    id: 'visionary',
    name: 'Visionary',
    tagline: "You see what others can't.",
    description: 'Privești dincolo de aparențe. Gândești diferit.',
    color: '#64748b',
    colorLight: '#94a3b8',
    gradient: 'linear-gradient(135deg, #1e293b 0%, #475569 50%, #94a3b8 100%)',
    glowColor: 'rgba(100, 116, 139, 0.6)',
    badgeColor: '#475569',
  },
}

export const PERSONA_PROMPTS = {
  courageous: {
    image: (gender) =>
      `Transform this ${gender === 'male' ? 'man' : 'woman'} into a fearless urban warrior standing in a dramatic orange and gold neon-lit cityscape at night. Confident stance, leather jacket with metallic accents, fire and embers in the background. Photorealistic, highly detailed, dramatic cinematic lighting. Preserve exact facial features, skin tone, hair, and identity unchanged. Single figure only.`,
    video:
      'The fearless urban warrior turns to face the camera, orange embers drifting past, neon city lights pulsing. Slow cinematic motion, confident powerful energy, fire reflecting on their face.',
  },
  inspirational: {
    image: (gender) =>
      `Transform this ${gender === 'male' ? 'man' : 'woman'} into a radiant, glowing presence surrounded by teal and emerald neon light particles in a dark ethereal space. Inspiring, uplifting pose, light emanating from them. Photorealistic, highly detailed, magical cinematic lighting. Preserve exact facial features, skin tone, hair, and identity unchanged. Single figure only.`,
    video:
      'The radiant figure glows brighter, teal light particles swirling and expanding outward. Slow cinematic motion, inspiring uplifting energy, light beams radiating.',
  },
  authentic: {
    image: (gender) =>
      `Transform this ${gender === 'male' ? 'man' : 'woman'} into a modern icon in a cool blue neon environment. Natural authentic pose, blue electric light, reflective surfaces. Photorealistic, highly detailed, cinematic. Preserve exact facial features, skin tone, hair, and identity unchanged. Single figure only.`,
    video:
      'The authentic figure looks directly into the camera, blue neon light flickering, electric particles dancing around them. Slow cinematic motion, genuine powerful energy.',
  },
  independent: {
    image: (gender) =>
      `Transform this ${gender === 'male' ? 'man' : 'woman'} into a bold independent spirit in a purple and violet neon environment. Free, powerful pose, purple light and smoke. Photorealistic, highly detailed, dramatic cinematic lighting. Preserve exact facial features, skin tone, hair, and identity unchanged. Single figure only.`,
    video:
      'The independent spirit moves freely, purple neon smoke swirling, violet particles drifting. Slow cinematic motion, free powerful energy.',
  },
  visionary: {
    image: (gender) =>
      `Transform this ${gender === 'male' ? 'man' : 'woman'} into a mysterious visionary in a dark silver and moonlit environment. Thoughtful distant gaze, ethereal dark atmosphere, silver light. Photorealistic, highly detailed, noir cinematic lighting. Preserve exact facial features, skin tone, hair, and identity unchanged. Single figure only.`,
    video:
      'The visionary gazes into the distance, silver moonlight shifting, dark ethereal mist swirling slowly. Slow cinematic motion, mysterious contemplative energy.',
  },
}
